// extracted by mini-css-extract-plugin
export default {"wrapper":"client-auto-login-loading_wrapper__82Qq2","icon":"client-auto-login-loading_icon__uWhpj","spin":"client-auto-login-loading_spin__9y4ii"};